

export default [
    {
        name: 'home',
        path: '/',
    }
];